module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1Go69"))).then(() => module.bundle.root('ewmtE'));